import { Loading } from '@100mslive/react-ui';
import { Button, Card, CardActions, CardContent, CircularProgress, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import {
    useStripe
} from '@stripe/react-stripe-js';
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

const CheckoutForm = ({ title, paymentInfo, userProfile, onSuccess }) => {
    const [elements, setElements] = useState(null);
    const [loading, setLoading] = useState(false);
    const curStripe = useStripe();

    useEffect(() => {
        if (elements) {
            var paymentElement = elements.create("payment", {
                wallets: {
                    applePay: "auto",
                    googlePay: "auto",
                },
            });

            paymentElement.mount("#payment-element");
        }
    }, [elements]);


    useEffect(() => {
        const getSecr = async () => {
            const pub_key = paymentInfo.secKey || localStorage.getItem("x-stripe-accessToken");
            if (pub_key) {
                const stripe = require("stripe")(pub_key);
                console.log(paymentInfo.amount);
                const paymentIntent = await stripe.paymentIntents.create({
                    amount: paymentInfo.amount ? Math.round(parseInt(paymentInfo.amount) * 100) : 500,
                    currency: paymentInfo.currency || "MYR",
                    description: title,
                    shipping: {
                        name: userProfile.fullName,
                        phone: userProfile.phone,
                        address: {
                            country: userProfile.country.isoCode,

                        },
                    },
                });
                var myElements = curStripe.elements({
                    clientSecret: paymentIntent.client_secret,
                });
                setElements(myElements);
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        }

        if (curStripe && !elements && !loading) {
            setLoading(true);
            getSecr();
        }
    }, [curStripe])

    const handleSubmit = async (event) => {
        if (event) {
            event.preventDefault();
        }

        if (!curStripe || !elements) {
            return;
        }
        setLoading(true);
        const { error } = await curStripe.confirmPayment({
            elements: elements,
            redirect: "if_required",
            confirmParams: {
                return_url: document.location.href,
                payment_method_data: {
                    billing_details: {
                        address: {
                            country: userProfile.country.isoCode,
                        },
                        email: userProfile.email,
                        phone: userProfile.phone,
                        name: userProfile.fullName,
                    }
                }
            },

        });

        setLoading(false);
        if (!error) {
            Swal.fire({
                title: "Payment Success",
                text: "Thanks for your contribution",
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                showConfirmButton: false,
                cancelButtonText: "Close",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
            });
            if (onSuccess) {
                onSuccess()
            }
        } else {
            Swal.fire({
                title: "Payment Failed",
                text: error.message,
                icon: "error",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                showConfirmButton: false,
                cancelButtonText: "Close",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
            });
        }
    };

    return (
        <form onSubmit={handleSubmit} className='relative'>
            <Alert severity='info'>
                You will be charged {paymentInfo.currency} {paymentInfo.amount}
            </Alert>
            <Grid container spacing={2} style={{ height: "100%" }}>
                <Grid item xs={12} sm={12}>
                    <Card elevation={0}>
                        <CardContent>
                            <div id="payment-element"></div>
                        </CardContent>

                        <CardActions>
                            {
                                loading && <CircularProgress style={{ position: "absolute", top: "45%", left: "45%" }} />
                            }
                            <Button
                                type="submit"
                                fullWidth
                                disabled={!curStripe || loading}
                                variant="contained"
                                color="secondary"
                                className="mb-2"
                            >
                                Pay Now
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
        </form>
    );
};

export default CheckoutForm;